import React from "react";
import { BRAND } from "../../brand";

const accentColor = BRAND.magenta;

const DimmerSlider = ({
  value,
  onChange,
  suppressPropagation = false,
  className = "",
  knobColor = accentColor,
  trackColor = accentColor,
}) => (
  <div
    className={`relative h-6 select-none ${className}`}
    onPointerDown={(e) => suppressPropagation && e.stopPropagation()}
  >
    <input
      type="range"
      min="0"
      max="100"
      value={value}
      onChange={(e) => onChange(Number(e.target.value))}
      onClick={(e) => suppressPropagation && e.stopPropagation()}
      className="absolute inset-0 z-20 w-full opacity-0 cursor-pointer"
    />
    <div className="absolute left-0 right-0 top-1/2 -translate-y-1/2 h-2 rounded-full bg-brand-navy overflow-hidden">
      <div
        className="absolute inset-y-0 left-0"
        style={{ backgroundColor: trackColor, width: `${value}%` }}
      />
    </div>
    <div
      className="absolute top-1/2 h-4 w-4 rounded-full shadow border transform -translate-y-1/2"
      style={{
        left: `calc(${value}% - 8px)`,
        backgroundColor: knobColor,
        borderColor: knobColor === "white" ? "#e2e8f0" : BRAND.pink,
        boxShadow:
          knobColor === "white" ? "0 0 0 2px rgba(0,0,0,0.35)" : undefined,
      }}
    />
  </div>
);

export default DimmerSlider;
